import { Image } from '@tribeplatform/gql-client/types'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { useColorSchemeContext } from '@tribeplatform/react-ui-kit/ThemeProvider'

export const Logo = ({ image: imageProp }: { image?: Image }) => {
  const { data: authToken } = useAuthToken()
  const { networkPublicInfo } = authToken || {}
  const { colorSchemeMode } = useColorSchemeContext()

  const { images } = networkPublicInfo || {}
  const fallbackLogo = images?.lightLogo ?? networkPublicInfo.logo

  const lightImage = imageProp ?? ((images?.lightLogo ?? fallbackLogo) as Image)
  const darkImage = imageProp ?? ((images?.darkLogo ?? fallbackLogo) as Image)

  const image = colorSchemeMode === 'dark' ? darkImage : lightImage

  const imageUrl = image?.urls?.small ?? image?.url

  if (!imageUrl) {
    return (
      <div className="flex space-s-2 items-center logo-image max-w-[300px]">
        <div className="font-medium truncate">{networkPublicInfo.name}</div>
      </div>
    )
  }

  if (colorSchemeMode === null) {
    // on SSR we don't have access to the colorSchemeMode, that's why we need to render both logos and let browser decide which one to show
    return (
      <div className="max-h-8 block logo-image max-w-[300px]">
        <img
          className="object-contain h-8 max-h-full max-w-full inline-block dark:hidden"
          src={lightImage?.urls?.small ?? lightImage?.url}
          alt={networkPublicInfo.name}
        />
        <img
          className="object-contain h-8 max-h-full max-w-full hidden dark:inline-block"
          src={darkImage?.urls?.small ?? darkImage?.url}
          alt={networkPublicInfo.name}
        />
      </div>
    )
  }

  let height
  let width
  if (image?.width && image.height) {
    height = 32
    width = Math.round((image.width * 32) / image.height)
  }

  return (
    <div className="max-h-8 block logo-image max-w-[300px]">
      <img
        className="object-contain h-8 max-h-full max-w-full"
        width={width}
        height={height}
        src={imageUrl}
        alt={networkPublicInfo.name}
      />
    </div>
  )
}
